export const userConstants = {
  LOGIN_REQUEST: "USERS_LOGIN_REQUEST",
  LOGIN_SUCCESS: "USERS_LOGIN_SUCCESS",
  LOGIN_FAILURE: "USERS_LOGIN_FAILURE",
  LOGIN_DEFAULT: "USERS_LOGIN_DEFAULT",
  LOGIN_LOCKED:  "USERS_LOGIN_LOCKED",
  SESSION_EXTEND_REQUEST: "SESSION_EXTEND_REQUEST",
  SESSION_EXTEND_SUCCESS: "SESSION_EXTEND_SUCCESS",
  SESSION_EXTEND_FAILURE: "SESSION_EXTEND_FAILURE",
  LOGOUT: "USERS_LOGOUT",
};
